import {CopilotAssignmentButton} from './CopilotAssignmentButton'
import {CopilotAssignmentModal} from './CopilotAssignmentModal'
import type {CopilotAssignmentBaseProps} from './copilot-assignment-types'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useState} from 'react'

export interface CopilotAssignmentModalButtonProps extends CopilotAssignmentBaseProps {
  className?: string
  insideSidePanel?: boolean
  'data-testid'?: string
}

/**
 * Combined button and modal component for Copilot-assisted issue assignment.
 * This component includes feature flag checks and permission validation.
 * For more granular control, use CopilotAssignmentButton and CopilotAssignmentModal separately.
 */
export function CopilotAssignmentModalButton({
  repository,
  issueNumber,
  onAssignmentComplete,
}: CopilotAssignmentModalButtonProps) {
  const [overlayOpen, setOverlayOpen] = useState(false)

  // Feature flag check
  const crossRepoAssignEnabled = isFeatureEnabled('issues_copilot_cross_repo_assign')

  const openOverlay = () => {
    setOverlayOpen(true)
  }

  const closeOverlay = () => {
    setOverlayOpen(false)
  }

  const handleAssignmentComplete = () => {
    closeOverlay()
    onAssignmentComplete?.()
  }

  // Don't render if feature is disabled or user lacks permissions
  if (!crossRepoAssignEnabled) {
    return null
  }

  return (
    <>
      <CopilotAssignmentButton onClick={openOverlay} />
      <CopilotAssignmentModal
        isOpen={overlayOpen}
        onClose={closeOverlay}
        repository={repository}
        issueNumber={issueNumber}
        onAssignmentComplete={handleAssignmentComplete}
      />
    </>
  )
}

try{ CopilotAssignmentModalButton.displayName ||= 'CopilotAssignmentModalButton' } catch {}